/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Meine personenbezogenen Daten nicht verkaufen oder weitergeben",
      "Bumble Date",
      "Unsere Apps",
      "Über uns",
      "Karriere",
      "Kontakt",
      "Investieren",
      "Der Shop",
      "Unternehmen",
      "App herunterladen",
      "Barrierefreiheit bei Bumble",
      "Richtlinien",
      "Cookies verwalten",
      "Modern Slavery Act",
      "Hinweis zur Datenerhebung",
      "Datenschutzrichtlinien",
      "AGB",
      "Rechtliches",
      "Washingtons Datenschutzrichtlinie für Gesundheitsdaten von Verbrauchern",
      "QR-Code scannen und Bumble-App holen",
      "Verträge hier kündigen",
      "Menü schließen",
      "Menü öffnen",
      "Sprachauswahl",
      "Fußzeile",
      "Barrierefreiheit bei Bumble",
      "Apple und das Apple logo sind Marken von Apple Inc.",
      "Bumble BFF",
      "Bumble Bizz",
      "Bumble Date",
      "Karriere",
      "Google Play ist eine Marke von Google LLC.",
      "Richtlinien",
      "Investoren",
      "Cookies verwalten",
      "Erklärung zum Modern Slavery Act",
      "Hinweis zur Datenerhebung",
      "Datenschutz",
      "Saisonale Dating-Ratgeber",
      "AGB",
      "Die App",
      "Washingtoner Datenschutzrichtlinie für Gesundheitsdaten von Verbrauchern",
      "Über uns",
      "Ambassadors",
      "Neue Freunde und deinen Tribe finden",
      "Beruflich netzwerken und die Karriere vorantreiben",
      "Eine Beziehung finden, etwas Lockeres oder irgendwas dazwischen",
      "The Buzz",
      "Mehr erfahren",
      "Im Reise-Modus die Welt erkunden",
      "Date",
      "Funktionen",
      "Compliments",
      "Verteile Komplimente, um herauszustechen und zu connecten.",
      "Entdecken",
      "Deine individuelle Seite mit Leuten, die zu dir passen, täglich aktualisiert.",
      "Inkognito-Modus",
      "Nutze Inkognito-Modus, wenn nur Leute dein Profil sehen sollen, die für dich infrage kommen, nicht dein Chef oder deine Verwandten.",
      "Live Match",
      "Bei einem Bumble-Event vor Ort ins Gespräch gekommen? Bleibt danach über die App in Kontakt.",
      "Opening Moves",
      "Leg deinen Opening Move fest und gib deinem Match ein Gesprächsthema vor, um den Chat zu starten.",
      "Snooze-Modus",
      "Pause vom Dating? Nutze den Snooze-Modus. Komm einfach zurück, wenn du wieder Lust hast und mach da weiter, wo du warst.",
      "SuperSwipe",
      "Ein Profil, das dir richtig gut gefällt? Zeig, dass es was besonderes ist, mit einem SuperSwipe.",
      "Reise-Modus",
      "Finde deinen Duty-Free-Snack und matche überall auf der Welt, mit dem Reise-Modus.",
      "Video-Chat",
      "Nutze Videochat und Audioanrufe, um den Vibe zu checken, bevor du auf ein Date gehst.",
      "Web-App",
      "Erlebe Bumble direkt in deinem Browser.",
      "Hol dir die Bumble-App",
      "BFF",
      "Sicherheit",
      "Storys",
      "Support",
      "Der Shop",
      "Hauptmenü",
      "Verteile Komplimente und heb dich von anderen ab.",
      "Compliments",
      "Features, die darauf ausgelegt sind, authentische, respektvolle und tiefgehende Connections zu ermöglichen.",
      "Verstecke dein Profil vor Boss, Family oder Ex-Partnern.",
      "Inkognito-Modus",
      "Pause vom Dating? Nutze den Snooze-Modus.",
      "Snooze-Modus",
      "Gibt’s jemanden, der dir gefällt? Dann zeig es.",
      "SuperSwipe",
      "Date erkunden",
      "Finde deinen Duty-Free-Snack und matche weltweit.",
      "Reise-Modus",
      "Erlebe echte Begegnungen, ohne das Haus zu verlassen.",
      "Video-Anrufe",
      "Unsere Leader tragen die Werte von Bumble in ihre Communitys.",
      "Community-Leader",
      "Features, die dir helfen, Gleichgesinnte zu finden und dich über gemeinsame Interessen zu vernetzen.",
      "Organisiere ein Gruppen-Meetup oder entdecke Events in deiner Nähe.",
      "Plans",
      "BFF entdecken",
      "Alle Tipps und Anregungen, die du brauchst, um Liebe und Freundschaft zu entdecken.",
      "Tipps und Geschichten, die dir dabei helfen, die Freundschaften zu finden, die du suchst.",
      "Alles über Freundschaft",
      "Von Tokio bis Toronto – entdecke die Liebe, die weltweit auf Bumble gefunden wird.",
      "Lovestorys",
      "Plane das perfekte Date – egal wann, wo oder mit wem du dich triffst.",
      "Saisonale Dating-Ratgeber",
      "Storys erkunden",
      "Mehr lesen",
      "Bumble auf {{social_network}}",
      "Kontakt",
      "Einloggen",
      "(opens in new window)",
      "FAQ",
      "Cookie Policy",
      "Bumble – Blog",
      "Karriere",
      "Chat",
      "Städte",
      "Cookies verwalten",
      "Copyright © 2006 bis heute. Bumble. Alle Rechte vorbehalten.",
      "Bericht: Zuversicht beim Dating",
      "Apple und das Apple logo sind Marken von Apple Inc.{{__EOL__}}Google Play ist eine Marke von Google LLC.",
      "Jetzt downloaden",
      "Facebook",
      "Wir sind auch hier:",
      "Hilfebereich",
      "Instagram",
      "Sprache",
      "LinkedIn",
      "Bumble ist Teil von Bumble Inc.",
      "Datenschutzrichtlinien",
      "Safety Centre",
      "Sitemap",
      "Erklärung zum Modern Slavery Act",
      "AGB",
      "Twitter"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "plural": [
                  "Tage",
                  "Tage",
                  "Tagen",
                  "Tage"
            ],
            "singular": [
                  "Tag",
                  "Tags",
                  "Tag",
                  "Tag"
            ]
      },
      "hour": {
            "plural": [
                  "Stunden",
                  "Stunden",
                  "Stunden",
                  "Stunden"
            ],
            "singular": [
                  "Stunde",
                  "Stunde",
                  "Stunde",
                  "Stunde"
            ]
      },
      "minute": {
            "plural": [
                  "Minuten",
                  "Minuten",
                  "Minuten",
                  "Minuten"
            ],
            "singular": [
                  "Minute",
                  "Minute",
                  "Minute",
                  "Minute"
            ]
      },
      "month": {
            "plural": [
                  "Monate",
                  "Monate",
                  "Monaten",
                  "Monate"
            ],
            "singular": [
                  "Monat",
                  "Monats",
                  "Monat",
                  "Monat"
            ]
      },
      "second": {
            "plural": [
                  "Sekunden",
                  "Sekunden",
                  "Sekunden",
                  "Sekunden"
            ],
            "singular": [
                  "Sekunde",
                  "Sekunde",
                  "Sekunde",
                  "Sekunde"
            ]
      },
      "year": {
            "plural": [
                  "Jahre",
                  "Jahre",
                  "Jahren",
                  "Jahre"
            ],
            "singular": [
                  "Jahr",
                  "Jahres",
                  "Jahr",
                  "Jahr"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
